import {
  ApiGetRequest,
  ApiPostRequest,
  //   ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Order Beli',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Order Beli',
        href: '/adm/logistic/order-beli/order-pembelian',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_order_beli',
    sortDesc: true,
    fields: [
      {
        key: 'code_order_beli',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'tgl_beli',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_buy',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
      {
        key: 'status_order_beli',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'code_order_beli',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'tgl_beli',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_buy',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
    ],
    journal: false,
    row_item: {
      description: '',
      id_product: '',
      item_acc: '',
      item_order: '',
      item_send: '',
      id_satuan: '',
      item_price: '',
      item_disc: '',
      item_disc_nominal: '',
      item_acc_disc: '',
      item_id_pajak: '',
      item_acc_tax: '',
      item_tax: '',
      item_persentase: 0,
      item_total: 0,
    },
    form: {
      code_beli: '',
      id_supplier: '',
      supplier_code: '',
      supplier_name: '',
      tgl_beli: '',
      tgl_faktur: '',
      tgl_kirim: '',
      id_currency: '',
      id_department: '',
      id_gudang: '',
      type_buy: false,
      type_payment: false,
      remark: '',
      term_payment: '',
      memo: '',
      other_cost: '',
      acc_other_cost: '',
      acc_other_cost_code: '',
      acc_other_cost_name: '',
      total_pajak: '',
      total_invoice: '',
      down_payment: '',
      id_um_beli: '',
      total_payment: '',
      acc_total_payment: '',
      acc_total_payment_code: '',
      acc_total_payment_name: '',
      status_beli: '',
      id_journal: '',
      id_sales: '',
      sales_code: '',
      sales_name: '',
      items: [
        {
          description: '',
          id_product: '',
          item_acc: '',
          item_order: '',
          item_send: '',
          id_satuan: '',
          item_price: '',
          item_disc: '',
          item_disc_nominal: '',
          item_acc_disc: '',
          item_id_pajak: '',
          item_acc_tax: '',
          item_tax: '',
          item_persentase: 0,
          item_total: 0,
        },
      ],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeOrderBeli(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        code_beli: '',
        id_supplier: '',
        supplier_code: '',
        supplier_name: '',
        tgl_beli: '',
        tgl_faktur: '',
        tgl_kirim: '',
        id_currency: '',
        id_department: '',
        id_gudang: '',
        type_buy: false,
        type_payment: false,
        remark: '',
        term_payment: '',
        memo: '',
        other_cost: '',
        acc_other_cost: '',
        acc_other_cost_code: '',
        acc_other_cost_name: '',
        total_pajak: '',
        total_invoice: '',
        down_payment: '',
        id_um_beli: '',
        total_payment: '',
        acc_total_payment: '',
        acc_total_payment_code: '',
        acc_total_payment_name: '',
        status_beli: '',
        id_journal: '',
        id_sales: '',
        sales_code: '',
        sales_name: '',
        items: [
          {
            description: '',
            id_product: '',
            item_acc: '',
            item_order: '',
            item_send: '',
            id_satuan: '',
            item_price: '',
            item_disc: '',
            item_disc_nominal: '',
            item_acc_disc: '',
            item_id_pajak: '',
            item_acc_tax: '',
            item_tax: '',
            item_persentase: 0,
            item_total: 0,
          },
        ],
      },
    });
  },
};

export const actions = {
  async getLastNoFaktur({ commit, state }) {
    commit('changeOrderBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/order-beli/last-id`);
    commit('changeOrderBeli', {
      form: {
        ...data.form,
        code_beli: result.data.object,
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListOrderBeli({ commit, state }) {
    commit('changeOrderBeli', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      for_invoice: data.for_invoice ? data.for_invoice : 0,
    };

    let result = await ApiGetRequest(`logistic/order-beli`, params);
    commit('changeOrderBeli', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getJournalInvoice({ commit }, payload = null) {
    commit('changeOrderBeli', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `logistic/order-beli/${payload.id}/journal`
    );
    commit('changeOrderBeli', {
      loading: false,
    });

    if (!result.error) {
      commit('changeOrderBeli', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getDetailOrderBeli({ commit, state }, payload = null) {
    commit('changeOrderBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/order-beli/${payload.id}`);
    commit('changeOrderBeli', {
      loading: false,
    });

    if (!result.error) {
      commit('changeOrderBeli', {
        detail: result.data.object,
        form: {
          ...data.form,
          ...result.data.object,
          tgl_faktur: result.data.object.tgl_faktur
            ? moment(result.data.object.tgl_faktur).format('DD/MM/YYYY')
            : '',
          type_buy:
            result.data.object.type_buy &&
            parseInt(result.data.object.type_buy) > 0
              ? 1
              : 0,
          type_payment:
            result.data.object.type_payment &&
            parseInt(result.data.object.type_payment) > 0
              ? 1
              : 0,
        },
      });
    }

    return !result.error ? true : false;
  },

  async approveDataOrder({ commit, dispatch }, payload = null) {
    commit('changeOrderBeli', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/order-beli/approve`, payload);

    commit('changeOrderBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async createOrderBeli({ commit, state, dispatch }) {
    commit('changeOrderBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('logistic/order-beli', data.form);

    commit('changeOrderBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateOrderBeli({ commit, state, dispatch }, payload = null) {
    commit('changeOrderBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `logistic/order-beli/${payload.id}`,
      data.form
    );

    commit('changeOrderBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
